import React from 'react';
import { Container } from 'semantic-ui-react';

import './FullWidthLayout.scss';

export default function FullWidthLayout(props) {
  const { children } = props;

  return (
    <Container fluid className="full-width-layout">
      {children}
    </Container>
  );
}
